import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/meeting-templates')({
  staticData: { breadcrumb: 'Авто-встречи' },
  component: () => <Outlet />,
});
